module.exports = __webpack_public_path__ + "img/confirm_btn.f4094900.png";